<template>
  <BaseFetchData :action="fetchData">
    <template #default="fetchDataProps">
      <div v-if="fetchDataProps.status.resolved" class="px-4 sm:px-6 py-10 bg-gray-100 min-h-full">
        <div class="w-full max-w-7xl mx-auto space-y-8">
          <div class="md:flex md:items-center md:justify-between">
            <div class="flex-1 min-w-0">
              <h2 class="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">
                {{ contactList.name }}
              </h2>
            </div>
          </div>

          <div>
            <div class="sm:hidden">
              <label for="tabs" class="sr-only">Select a tab</label>
              <!-- Use an "onChange" listener to redirect the user to the selected tab URL. -->
              <select
                id="tabs"
                name="tabs"
                class="block w-full focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
              >
                <option v-for="tab in tabs" :key="tab.label" :selected="tab.isActive()">
                  {{ tab.name }}
                </option>
              </select>
            </div>
            <div class="hidden sm:block">
              <div class="border-b border-gray-200">
                <nav class="-mb-px flex space-x-8" aria-label="Tabs">
                  <RouterLink
                    v-for="tab in tabs"
                    :key="tab.label"
                    :to="tab.route"
                    custom
                    v-slot="{ navigate, isActive }"
                  >
                    <a
                      :active="isActive"
                      @click="navigate"
                      :aria-current="tab.isActive() ? 'page' : undefined"
                      :class="[
                        tab.isActive()
                          ? 'border-indigo-500 text-indigo-600'
                          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                        'group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm cursor-pointer',
                      ]"
                    >
                      <span>{{ tab.label }}</span>
                      <span
                        v-if="tab.meta.count"
                        :class="[
                          tab.isActive()
                            ? 'bg-indigo-100 text-indigo-600'
                            : 'bg-gray-100 text-gray-900',
                          'hidden ml-3 py-0.5 px-2.5 rounded-full text-xs font-medium md:inline-block',
                        ]"
                        >{{ tab.meta.count }}</span
                      >
                    </a>
                  </RouterLink>
                </nav>
              </div>
            </div>
          </div>
        </div>
        <div class="w-full max-w-7xl mx-auto my-10">
          <RouterView :contact-list="contactList" />
        </div>
      </div>
    </template>
  </BaseFetchData>
</template>

<script>
import { contactListsClient } from '@/api/clients';

export default {
  props: {
    contactListId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      contactList: null,
    };
  },
  computed: {
    tabs() {
      if (this.contactList === null) {
        return [];
      }

      const vm = this;

      return [
        {
          label: 'Overview',
          route: {
            name: 'accounts.contactLists.contactListId',
            params: {
              accountId: this.contactList.account_id,
              contactListId: this.contactListId,
            },
          },
          meta: {},
          isActive() {
            return vm.$route.name === this.route.name;
          },
        },
        {
          label: 'Settings',
          route: {
            name: 'accounts.contactLists.contactListId.settings',
            params: {
              accountId: this.contactList.account_id,
              contactListId: this.contactListId,
            },
          },
          meta: {},
          isActive() {
            return vm.$route.name === this.route.name;
          },
        },
        {
          label: 'Subscriptions',
          route: {
            name: 'accounts.contactLists.contactListId.subscriptions',
            params: {
              accountId: this.contactList.account_id,
              contactListId: this.contactListId,
            },
          },
          meta: {
            count: this.contactList.active_subscriptions_count,
          },
          isActive() {
            return vm.$route.name === this.route.name;
          },
        },
      ];
    },
  },
  watch: {
    '$route.query': {
      handler(newQuery) {
        if (newQuery.unsubscribed) {
          this.fetchData();
        }
        if (newQuery.updated) {
          this.fetchData();
        }
      },
    },
  },
  methods: {
    fetchData() {
      return contactListsClient
        .read(this.contactListId, {
          include: 'account,subscriptionsCount,activeSubscriptionsCount,runningJobBatchesCount',
        })
        .then((response) => {
          this.contactList = response.data || null;

          return Promise.resolve(response);
        });
    },
  },
};
</script>
